import { Roles } from 'Constants/Roles'
import { NotificationUITypes, UITypes } from 'LibNeo'
import { SETTING_KEY_USER } from 'Modules'

export const NOT_AGENT_ROLES = [
	Roles.SUPER_ADMIN,
	Roles.ADMIN,
	Roles.MANAGER_DS,
	Roles.TECH_SUPPORT,
]

export const AGENT_ROLES = [Roles.RUKOVODITEL]

export const SBER_ROLES = [Roles.SBER_MANAGER]

export const SETTINGS_KEY = SETTING_KEY_USER.REGISTRY_BUSINESS_ACCESS

export enum Slugs {
	ACTION = 'action',
	LAST_NAME = 'last_name',
	CREATED_AT = 'created_at',
	TERRITORIAL_BANK = 'territorial_bank',
	ENTITY_INN = 'entity_inn',
	INFOTECS_ID = 'infotecs_id',
	USERNAME = 'username',
	PHONE = 'phone',
	EMAIL = 'email',
}

export enum StatusRbidosSlug {
	DRAFT = 'draft',
	APPROVED = 'approved',
	REJECTED = 'rejected',
	CREATING = 'creating',
	WAIT_SIGNATURE = 'wait_signature',
	COMPLETE = 'complete',
	ERROR = 'error',
	AT_VERIFICATION = 'at_verification',
	SENT = 'sent',
	RETURN = 'return',
	REFUSAL = 'refusal',
	INFOTECS_DRAFT = 'infotecs_draft',
	INFOTECS_APPROVED = 'infotecs_approved',
	INFOTECS_REJECTED = 'infotecs_rejected',
	INFOTECS_CREATING = 'infotecs_creating',
	INFOTECS_WAIT_SIGNATURE = 'infotecs_wait_signature',
	INFOTECS_COMPLETE = 'infotecs_complete',
	INFOTECS_ERROR = 'infotecs_error',
	DELETED = 'deleted',
	CORRECTION = 'correction',
	INFOTECS_WAIT_EXTERNAL_SIGNATURE = 'infotecs_wait_external_signature',
	VERIFICATION_OF_SIGNATURE = 'verification_of_signature',
}

export const RbidosStatusTranslate = {
	[StatusRbidosSlug.DRAFT]: 'Черновик',
	[StatusRbidosSlug.APPROVED]: 'Одобрено ИИТ',
	[StatusRbidosSlug.REJECTED]: 'Отклонено ИИТ',
	[StatusRbidosSlug.CREATING]: 'Подписанту отправлена смс',
	[StatusRbidosSlug.WAIT_SIGNATURE]: 'Подписание документов',
	[StatusRbidosSlug.COMPLETE]: 'Зарегистрировано',
	[StatusRbidosSlug.ERROR]: 'Ошибка',
	[StatusRbidosSlug.AT_VERIFICATION]: 'На проверке',
	[StatusRbidosSlug.SENT]: 'Отправлено',
	[StatusRbidosSlug.RETURN]: 'Возврат ДС',
	[StatusRbidosSlug.REFUSAL]: 'Отклонено',
	[StatusRbidosSlug.INFOTECS_DRAFT]: 'На рассмотрении ИИТ',
	[StatusRbidosSlug.INFOTECS_APPROVED]: 'Одобрено ИИТ',
	[StatusRbidosSlug.INFOTECS_REJECTED]: 'Отклонено ИИТ',
	[StatusRbidosSlug.INFOTECS_CREATING]: 'Подписанту отправлена СМС',
	[StatusRbidosSlug.INFOTECS_WAIT_SIGNATURE]: 'Подписание документов',
	[StatusRbidosSlug.INFOTECS_COMPLETE]: 'Зарегистрировано',
	[StatusRbidosSlug.INFOTECS_ERROR]: 'Ошибка регистрации',
	[StatusRbidosSlug.DELETED]: 'Удалено',
	[StatusRbidosSlug.CORRECTION]: 'На коррекции',
	[StatusRbidosSlug.INFOTECS_WAIT_EXTERNAL_SIGNATURE]: 'На подписании партнером',
	[StatusRbidosSlug.VERIFICATION_OF_SIGNATURE]: 'На проверке документов в ИИТ',
}

export const notificationShowByStatusExcluded = [
	StatusRbidosSlug.DRAFT,
	StatusRbidosSlug.INFOTECS_WAIT_EXTERNAL_SIGNATURE,
]

export const status_rbidos: Record<
	StatusRbidosSlug | string,
	{
		message: string
		title?: string
		type?: NotificationUITypes
		hideIcon?: boolean
	}
> = {
	[StatusRbidosSlug.DRAFT]: {
		title: '',
		message: 'rbidos_access.status_draft',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.APPROVED]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_approved',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.COMPLETE]: {
		title: 'РБиДОС доступен',
		message: 'rbidos_access.status_infotecs_complete',
		type: UITypes.PRIMARY,
		hideIcon: false,
	},
	[StatusRbidosSlug.AT_VERIFICATION]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_at_verification',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.SENT]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_at_verification',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.INFOTECS_DRAFT]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_draft',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.INFOTECS_APPROVED]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_approved',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.INFOTECS_COMPLETE]: {
		title: 'РБиДОС доступен',
		message: 'rbidos_access.status_infotecs_complete',
		type: UITypes.PRIMARY,
		hideIcon: false,
	},
	[StatusRbidosSlug.VERIFICATION_OF_SIGNATURE]: {
		title: 'Ожидание ответа',
		message: 'rbidos_access.status_infotecs_approved',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.INFOTECS_WAIT_EXTERNAL_SIGNATURE]: {
		title: 'Подпишите документы',
		message: 'rbidos_access.status_infotecs_wait_external_signature',
		type: UITypes.WARNING,
	},
	[StatusRbidosSlug.RETURN]: {
		title: '',
		message: '',
		type: UITypes.WARNING,
	},
}
